module.exports = __webpack_public_path__ + "static/signup-success-1ade2f455fc24643dffde5c7dfc401e7.png";